"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const icon_1 = require("../../../components/icon/icon");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const appMessageLayout_1 = __importDefault(require("../../../components/appMessage/appMessageLayout"));
const store_1 = require("../../../store");
const authSlice_1 = require("../authSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const analytics_1 = require("../../../utils/analytics/analytics");
const EmailConfirmation = ({ route }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { params } = route;
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const navigation = (0, useAppNavigation_1.default)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [errors, setErrors] = (0, react_1.useState)();
    const [message, setMessage] = (0, react_1.useState)('');
    const tryUserConfirmEmail = async () => {
        const confirmationToken = params ? params.token : '';
        if (confirmationToken !== '') {
            setIsLoading(true);
            const result = await dispatch((0, authSlice_1.userConfirmEmail)({ token: confirmationToken }));
            logEventWithExtraProperties('api_call', {
                name: 'confirm_user_email',
                status: 'submitted',
                location: 'screen_EmailConfirmation',
            });
            if ((0, toolkit_1.isFulfilled)(result)) {
                logEventWithExtraProperties('api_call', {
                    name: 'confirm_user_email',
                    status: 'success',
                    location: 'screen_EmailConfirmation',
                });
                setIsLoading(false);
                navigation.navigate(screenConstants_1.EMAIL_CONFIRMED_SCREEN);
            }
            else {
                logEventWithExtraProperties('api_call', {
                    name: 'confirm_user_email',
                    status: 'fail',
                    location: 'screen_EmailConfirmation',
                });
                setMessage('');
                setErrors(result.payload);
                setIsLoading(false);
            }
        }
    };
    const performSendEmailVerification = async () => {
        setIsLoading(true);
        const result = await dispatch((0, authSlice_1.requestConfirmEmail)());
        logEventWithExtraProperties('api_call', {
            name: 'request_send_email_verification',
            status: 'submitted',
            location: 'screen_EmailConfirmation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'request_send_email_verification',
                status: 'success',
                location: 'screen_EmailConfirmation',
            });
            setMessage(result.payload.message);
            setErrors(undefined);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'request_send_email_verification',
                status: 'fail',
                location: 'screen_EmailConfirmation',
            });
            setMessage('');
            setErrors(result.payload);
        }
        setIsLoading(false);
    };
    return (react_1.default.createElement(appMessageLayout_1.default, { isLoading: isLoading, errors: errors, icon: icon_1.EMAIL_VECTOR_ICON, message: message, textTitle: "Almost there", textSubtitle: "Click the button bellow to continue.", buttonTextPrimary: "Complete Verification", onPressPrimary: tryUserConfirmEmail, eventNamePrimary: "complete_email_verification", onPressSecundary: errors ? performSendEmailVerification : () => { }, preLinkTextSecundary: errors ? 'Having issues? ' : '', buttonTextSecundary: errors ? 'Resend Email' : '', eventNameSecundary: "resend_email_verification" }));
};
exports.default = EmailConfirmation;
